/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { SupersetTheme } from '@superset-ui/core';

export const EDITOR_MODAL_DIMENSIONS = {
  containerHeight: 'min(76vh, 680px)',
  containerMinHeight: 680,
  splitPaneWidthUnits: 80,
  splitLayoutBreakpointUnits: 270,
  heroStackBreakpointUnits: 240,
  formGridBreakpointUnits: 320,
} as const;

export const EDITOR_MODAL_TOKENS = {
  paneRadiusUnits: 4,
  cardRadiusUnits: 3,
  compactRadiusUnits: 2,
  mediumRadiusUnits: 2.5,
  largeRadiusUnits: 3.5,
} as const;

export const getEditorPanelBorder = (theme: SupersetTheme) =>
  `1px solid ${theme.colors.grayscale.light3}`;

export const getEditorCanvasGradient = (theme: SupersetTheme) =>
  theme.colors.grayscale.light5;

export const getEditorHeroGradient = (theme: SupersetTheme) =>
  theme.colors.grayscale.light5;

export const getEditorPaneShadow = () => 'none';

export const getEditorHeroShadow = () => 'none';

export const getEditorSectionShadow = () => 'none';

export const getEditorRaisedIconShadow = () => 'none';
